import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { Tooltip } from "@mui/material";

export const TemperatureClass = {
	T1: "T > 450",
	T2: "300 < T ≤ 450",
	T3: "200 < T ≤ 300",
	T4: "135 < T ≤ 200",
	T5: "100 < T ≤ 135",
	T6: "85 < T ≤ 100",
};

export const ProductTemperatureClass = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return <Select
		disableSearch
		fetchOptions={Object.keys(TemperatureClass)}
		getOptionLabel={opt => getLabel(opt as keyof typeof TemperatureClass)}
		value={value}
		onChange={onChange}
	/>;
};

function getLabel(temperatureClass: keyof typeof TemperatureClass) {
	return `${temperatureClass}. ${TemperatureClass[temperatureClass]}`;
}

// eslint-disable-next-line react-refresh/only-export-components
export function productTemperatureClassField(temperatureClass: string | undefined | null) {
	if (!temperatureClass || !(temperatureClass in TemperatureClass)) {
		return "-";
	}
	const key = temperatureClass as keyof typeof TemperatureClass;
	return <Tooltip title={TemperatureClass[key]} placement="right"><span>{key}</span></Tooltip>;
}
